export default __webpack_public_path__ + "static/media/Notif - POSTPONED.8eb50fe2.svg";